import { h as useAppSelector, i as mainSlice, k as renderersLoadComponent, _ as __variableDynamicImportRuntimeHelper } from "./doenetml-CDvV96YD.js";
import React__default, { useState, useEffect } from "react";
function useDoenetRenderer(props, initializeChildrenOnConstruction = true) {
  const actions = props.componentInstructions.actions;
  const componentIdx = props.componentInstructions.componentIdx;
  const effectiveIdx = props.componentInstructions.effectiveIdx;
  const id = props.componentInstructions.id;
  const rendererName = props.coreId + componentIdx;
  const [renderersToLoad, setRenderersToLoad] = useState({});
  const componentInfo = useAppSelector(
    (state) => mainSlice.selectors.componentInfo(state)[rendererName]
  );
  const {
    stateValues,
    sourceOfUpdate = {},
    ignoreUpdate,
    childrenInstructions,
    prefixForIds
  } = componentInfo || {
    stateValues: {},
    sourceOfUpdate: {},
    ignoreUpdate: false,
    childrenInstructions: [],
    prefixForIds: ""
  };
  let children = [];
  const loadMoreRenderers = Object.keys(renderersToLoad).length === 0;
  for (let childInstructions of childrenInstructions) {
    let child = createChildFromInstructions(
      childInstructions,
      loadMoreRenderers
    );
    children.push(child);
  }
  useEffect(() => {
    if (Object.keys(renderersToLoad).length > 0) {
      renderersLoadComponent(
        Object.values(renderersToLoad),
        Object.keys(renderersToLoad)
      ).then((newRendererClasses) => {
        Object.assign(props.rendererClasses, newRendererClasses);
        setRenderersToLoad({});
      });
    }
  }, [renderersToLoad, props.rendererClasses]);
  function createChildFromInstructions(childInstructions, loadMoreRenderers2) {
    if (typeof childInstructions === "string" || childInstructions === null) {
      return childInstructions;
    }
    let propsForChild = {
      key: props.coreId + childInstructions.componentIdx,
      componentInstructions: childInstructions,
      rendererClasses: props.rendererClasses,
      coreId: props.coreId,
      docId: props.docId,
      activityId: props.activityId,
      callAction: props.callAction,
      fetchExternalDoenetML: props.fetchExternalDoenetML,
      requestScrollTo: props.requestScrollTo,
      flags: props.flags
    };
    let rendererClass = props.rendererClasses[childInstructions.rendererType];
    if (!rendererClass) {
      if (loadMoreRenderers2) {
        setRenderersToLoad((old) => {
          let rendererPromises = { ...old };
          if (!(childInstructions.rendererType in rendererPromises)) {
            rendererPromises[childInstructions.rendererType] = __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./renderers/_error.tsx": () => import("./_error-BrARk5Fx.js"), "./renderers/alert.tsx": () => import("./alert-DfLMIJuf.js"), "./renderers/angle.tsx": () => import("./angle-Cgzhzg0n.js"), "./renderers/answer.tsx": () => import("./answer-18Cp2Pm0.js"), "./renderers/asList.tsx": () => import("./asList-DI0LB2Ml.js"), "./renderers/blockQuote.tsx": () => import("./blockQuote-B-pRp9mk.js"), "./renderers/boolean.tsx": () => import("./boolean-Bh-uG4Kk.js"), "./renderers/booleanInput.tsx": () => import("./booleanInput-B3eP77t2.js"), "./renderers/br.tsx": () => import("./br-CHaEnqQZ.js"), "./renderers/button.tsx": () => import("./button-C5_qKwMr.js"), "./renderers/c.tsx": () => import("./c-D83tkoY-.js"), "./renderers/cell.tsx": () => import("./cell-gcpABQHb.js"), "./renderers/choiceInput.tsx": () => import("./choiceInput-CIweZgnj.js"), "./renderers/circle.tsx": () => import("./circle-D8x7L58k.js"), "./renderers/cobwebPolyline.tsx": () => import("./cobwebPolyline-B-PF70nu.js"), "./renderers/codeEditor.tsx": () => import("./codeEditor-C7JRQ30n.js"), "./renderers/containerBlock.tsx": () => import("./containerBlock-q8zkAcAo.js"), "./renderers/containerInline.tsx": () => import("./containerInline-Z9K4BoDE.js"), "./renderers/curve.tsx": () => import("./curve-DQQ_i75j.js"), "./renderers/ellipsis.tsx": () => import("./ellipsis-BLSUnRdh.js"), "./renderers/em.tsx": () => import("./em-MZuySG0G.js"), "./renderers/embed.tsx": () => import("./embed-7Wp0RcoT.js"), "./renderers/feedback.tsx": () => import("./feedback-BcehF_7L.js"), "./renderers/figure.tsx": () => import("./figure-SpAf6tQb.js"), "./renderers/footnote.tsx": () => import("./footnote-Dr_pVPk9.js"), "./renderers/graph.tsx": () => import("./graph-BnCXdKYm.js"), "./renderers/hint.tsx": () => import("./hint-C-VckoiW.js"), "./renderers/hr.tsx": () => import("./hr-CXSU5Oif.js"), "./renderers/image.tsx": () => import("./image-D8QPz-J7.js"), "./renderers/label.tsx": () => import("./label-DGgSGSs2.js"), "./renderers/legend.tsx": () => import("./legend-DMzfTBYa.js"), "./renderers/line.tsx": () => import("./line-cFSBunBC.js"), "./renderers/lineSegment.tsx": () => import("./lineSegment-hnx1NqdL.js"), "./renderers/list.tsx": () => import("./list-D2CwsUUP.js"), "./renderers/lq.tsx": () => import("./lq-d-Ji-mUH.js"), "./renderers/lsq.tsx": () => import("./lsq-DkTVJc5V.js"), "./renderers/math.tsx": () => import("./math-CNEtKCI7.js"), "./renderers/mathInput.tsx": () => import("./mathInput-CX_uwjPd.js"), "./renderers/matrixInput.tsx": () => import("./matrixInput-5CijX7lS.js"), "./renderers/mdash.tsx": () => import("./mdash-Bs6HPbX1.js"), "./renderers/nbsp.tsx": () => import("./nbsp-BQlbE_ub.js"), "./renderers/ndash.tsx": () => import("./ndash-BG8r5c8d.js"), "./renderers/number.tsx": () => import("./number-CBPH0jPR.js"), "./renderers/orbitalDiagram.tsx": () => import("./orbitalDiagram-C0HvdDZX.js"), "./renderers/orbitalDiagramInput.tsx": () => import("./orbitalDiagramInput-CSpvyh09.js"), "./renderers/p.tsx": () => import("./p-DD64r37C.js"), "./renderers/paginatorControls.tsx": () => import("./paginatorControls-CsgeacGg.js"), "./renderers/pegboard.tsx": () => import("./pegboard-0Wx-yPVj.js"), "./renderers/point.tsx": () => import("./point-CaZ-4F3P.js"), "./renderers/polygon.tsx": () => import("./polygon-DBMvZ5GT.js"), "./renderers/polyline.tsx": () => import("./polyline-DqW30STC.js"), "./renderers/pre.tsx": () => import("./pre-MtfB0_w2.js"), "./renderers/pretzel.tsx": () => import("./pretzel-CInR_-wU.js"), "./renderers/q.tsx": () => import("./q-CD7bAFEY.js"), "./renderers/ray.tsx": () => import("./ray-DsMD9jnR.js"), "./renderers/ref.tsx": () => import("./ref-ZneYHOUr.js"), "./renderers/regionBetweenCurveXAxis.tsx": () => import("./regionBetweenCurveXAxis-CJoVI5Lt.js"), "./renderers/regionBetweenCurves.tsx": () => import("./regionBetweenCurves-BMhw0Boa.js"), "./renderers/row.tsx": () => import("./row-YXg8D46e.js"), "./renderers/rq.tsx": () => import("./rq-CAor4h45.js"), "./renderers/rsq.tsx": () => import("./rsq-BUcmomj7.js"), "./renderers/section.tsx": () => import("./section-DApLx4Um.js"), "./renderers/sideBySide.tsx": () => import("./sideBySide-DsE4E5fz.js"), "./renderers/slider.tsx": () => import("./slider-CULT6y8Q.js"), "./renderers/solution.tsx": () => import("./solution-Bop9h1JU.js"), "./renderers/spreadsheet.tsx": () => import("./spreadsheet-CT1OsIcA.js"), "./renderers/sq.tsx": () => import("./sq-CVq0CAKv.js"), "./renderers/subsetOfRealsInput.tsx": () => import("./subsetOfRealsInput-DOuwuD0S.js"), "./renderers/summaryStatistics.tsx": () => import("./summaryStatistics-UkLlnT-n.js"), "./renderers/table.tsx": () => import("./table-jxsuCrwt.js"), "./renderers/tabular.tsx": () => import("./tabular-BF3RRZsS.js"), "./renderers/tag.tsx": () => import("./tag-KGFz2xPN.js"), "./renderers/text.tsx": () => import("./text-DsAFp_VY.js"), "./renderers/textInput.tsx": () => import("./textInput-DY_pGVok.js"), "./renderers/vector.tsx": () => import("./vector-PxTMsQM7.js"), "./renderers/video.tsx": () => import("./video-CWCqGFjO.js") }), `./renderers/${childInstructions.rendererType}.tsx`, 3);
          }
          return rendererPromises;
        });
      }
      return null;
    }
    let child = React__default.createElement(rendererClass, propsForChild);
    return child;
  }
  let rendererType = props.componentInstructions.rendererType;
  const callAction = (argObj) => {
    if (!argObj.componentIdx) {
      argObj = { ...argObj };
      argObj.componentIdx = componentIdx;
    }
    if (!argObj.rendererType) {
      argObj = { ...argObj };
      argObj.rendererType = rendererType;
    }
    return props.callAction(argObj);
  };
  return {
    componentIdx: effectiveIdx,
    id: prefixForIds + id,
    SVs: stateValues,
    docId: props.docId,
    activityId: props.activityId,
    actions,
    children,
    sourceOfUpdate,
    ignoreUpdate,
    rendererName,
    initializeChildren: () => {
    },
    callAction,
    doenetViewerUrl: props.doenetViewerUrl,
    fetchExternalDoenetML: props.fetchExternalDoenetML,
    requestScrollTo: props.requestScrollTo,
    flags: props.flags
  };
}
export {
  useDoenetRenderer as u
};
